import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Core2Config } from "../shared/core2Config";
import { WmsPutawayQueueContainerModel } from "../../../../../models/aggregates/warehouse/index";
import { ApiResponseModel } from "../shared";
import { ApiVisa } from "../shared";
import { Observable } from 'rxjs';

@Injectable({ providedIn: "root" })
export class WmsPutawayProcessingQueueService extends BaseApiTemplateService<WmsPutawayQueueContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouse/wms-putaway-processing-queues";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouse/wms-putaway-processing-queues/backoffice-ep";
    this.httpClient = http;
  }


}
